let loopLogicCheck = 100
export function reconcileSchemas(
  pageBakedSchemaObject: Record<string, unknown>,
  localSchemaObject: null | Record<string, unknown>
): [Record<string, unknown>, boolean] {
  if (!localSchemaObject) {
    return [pageBakedSchemaObject, true]
  }
  if (
    pageBakedSchemaObject.version &&
    localSchemaObject.version &&
    localSchemaObject.version === pageBakedSchemaObject.version
  ) {
    return [localSchemaObject, false]
  }

  let newLocalSchema = localSchemaObject
  while (
    !newLocalSchema.version ||
    (pageBakedSchemaObject.version && newLocalSchema.version !== pageBakedSchemaObject.version)
  ) {
    newLocalSchema = reconcileForVersion(
      (newLocalSchema as { version?: string }).version,
      (pageBakedSchemaObject as { version?: string }).version,
      newLocalSchema,
      pageBakedSchemaObject
    )
    if (--loopLogicCheck < 0) {
      // eslint-disable-next-line no-console
      console.warn(
        'Infinite loop detected while reconciling schemas. Versions:',
        newLocalSchema.version,
        pageBakedSchemaObject.version
      )
      break
    }
  }

  return [newLocalSchema, true]
}

function reconcileForVersion(
  localVersion: string | null = '0.0.0',
  remoteVersion: string | null = '0.0.0',
  localSchema: Record<string, unknown>,
  remoteSchema: Record<string, unknown>
): Record<string, unknown> {
  switch (remoteVersion) {
    case '1.0.0': {
      return migrateTo100(remoteVersion, localSchema, remoteSchema)
    }
    case '1.0.3':
    case '1.0.4': {
      return localSchema
    }
    default: {
      localSchema.version = localVersion
      remoteSchema.version = remoteVersion
      return remoteSchema
    }
  }
}

function migrateTo100(
  version: string,
  localSchema: Record<string, unknown>,
  remoteSchema: Record<string, unknown>
): Record<string, unknown> {
  // Migrate some groups and sections from remoteSchema to match the structure of remoteSchema

  const remoteBlocks = remoteSchema['blocks'] as Array<Record<string, { uid: string; sections: unknown }>>
  const localBlocks = localSchema['blocks'] as Array<Record<string, { uid: string; sections: unknown }>>

  const nextBlocks = remoteBlocks
    .map(block => {
      const localBlock = localBlocks.find(b => b.uid === block.uid)
      if (localBlock) {
        return {
          ...block,
          sections: localBlock.sections ?? block.sections
        }
      }
      return block
    })
    .concat(
      localBlocks.filter(b => !remoteBlocks.some(rb => rb.uid === b.uid)).map(b => Object.assign(b, { sections: [] }))
    )

  const migratedSchema = {
    ...localSchema,
    // Update the version to match the remote schema version
    version,
    groups: localSchema.groups ?? remoteSchema['groups'],
    blocks: nextBlocks
  }

  return migratedSchema
}
